export default "__VITE_ASSET__CCp7Q6EI__"